export function bodyCtrl(mode) {
    if(mode === 'unlock') {
        document.body.style.overflow = 'visible'
    }if(mode === 'lock') {
        document.body.style.overflow = 'hidden'
    }
}

export const LocStore = (key, value = null) => {
    if (value) {
        value = (typeof value === 'object') ? JSON.stringify(value) : value;
        localStorage.setItem(key, value)
        return true;
    } else {
        const _val = localStorage.getItem(key);
        try {
            return JSON.parse(_val);
        } catch (e) {
            if (_val.indexOf('object Object') > -1) {
                localStorage.removeItem(key);
                return null;
            }
            return _val;
        }
    }
}

export const setPositon = (selector) => {
    const el = document?.querySelector(selector) ?? null
    return {
        targetH: el?.offsetHeight ?? 0
    }
}
